import { render, staticRenderFns } from "./filterBox.vue?vue&type=template&id=013bf437"
import script from "./filterBox.vue?vue&type=script&lang=js"
export * from "./filterBox.vue?vue&type=script&lang=js"
import style0 from "./filterBox.vue?vue&type=style&index=0&id=013bf437&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports